<template>
  <form class="d-flex flex-fill">
    <div class="input-group">
      <div class="input-group-prepend">
        <button class="btn btn-default" type="button">
          <i class="pe pe-7s-search pe-2x"></i>
        </button>
      </div>
      <input input-class="form-control" style="border:none;" placeholder="Išči ...">
    </div>
  </form>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  export default {
    name: "SearchForm",
    components: {
      Datepicker
    }
  }
</script>
